import { Box, Divider, Typography } from '@mui/material';

type Props = {
    children: string;
}

export const PageTitle = ({ children }: Props) => {
    return (
        <Box py={1} data-testid="page-title">
            <Typography data-testid="page-title" variant="h6" px={1}>
                {children}
            </Typography>
            <Divider />
        </Box>
    )
}
